import type { ReactNode } from 'react'
import { PageShell } from '@/components/layout/PageShell'
import { PlayBackButton } from '@/components/play/PlayBackButton'
import { cn } from '@/lib/utils'

interface PlayShellProps {
	children: ReactNode
	className?: string
	footer?: ReactNode
}

export function PlayShell({ children, className, footer }: PlayShellProps) {
	return (
		<PageShell size='play' gap='6' footer={footer}>
			{/* Stack until xl so the game keeps full width on phone / tablet / 1024 laptop. */}
			<div className='flex w-full min-w-0 flex-col gap-3 xl:flex-row xl:gap-4'>
				<div className='shrink-0 self-start'>
					<PlayBackButton />
				</div>
				<div className={cn('flex w-full min-w-0 flex-1 flex-col gap-6', className)}>{children}</div>
			</div>
		</PageShell>
	)
}
